<span #origin class="wrapper" (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()"><img class="icon-image" src="/assets/icon-question.svg" alt="?" width="16" height="16"></span>
<ng-template #popup><div class="popup"><ng-content></ng-content></div></ng-template>
